import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';

export class ExemptVendorType extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ExemptVendorTypeProperties: (
    | {
        property: keyof ExemptVendorType;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ExemptVendorType;
        type: 'alias';
      }
    | {
        property: keyof ExemptVendorType;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'type', type: 'column', dataType: 'string' },
    { property: 'isTaxIdRequired', type: 'column', dataType: 'boolean' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    ExemptVendorType.ExemptVendorTypeProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        ExemptVendorType.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        ExemptVendorType.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        ExemptVendorType.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(ExemptVendorTypeObject: Partial<ExemptVendorType>) {
    super();

    ExemptVendorType.ExemptVendorTypeProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = ExemptVendorTypeObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  type?: string;
  isTaxIdRequired?: boolean;
  CompanyId?: number;
  createdAt?: Date;
  updatedAt?: Date;
}
